import { NgModule } from '@angular/core';
import { MsInputTextareaComponent } from './ms-input-textarea.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsInputTextareaComponent],
	imports: [SharedLibsModule],
	exports: [MsInputTextareaComponent],
	providers: [],
})
export class MsInputTextareaModule {}
